module.exports = __webpack_public_path__ + "static/media/password.d78a9e47.svg";